"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSaveUserAvatarQuery = exports.useSaveUserSettingQuery = exports.useSaveUserDataQuery = exports.useGetVerifyUserAccess = exports.getVerifyUserAccessQuery = exports.useSendUserInvitationQuery = exports.useGetUserByEmailQuery = exports.userByIdQuery = exports.useGetUsersByRoleId = exports.getUsersByRoleId = exports.useGetUserQuery = exports.getUserQuery = exports.userQuery = void 0;
const react_query_1 = require("@tanstack/react-query");
const pino_1 = __importDefault(require("pino"));
const appConstants_1 = require("../constants/appConstants");
const userRepository_1 = __importDefault(require("../repositories/userRepository"));
const userSettingRepository_1 = require("../repositories/userSettingRepository");
const Root_1 = require("../router/Root");
const avatarUtils_1 = require("../utils/avatarUtils");
const query_keys_1 = require("./query-keys");
const logger = (0, pino_1.default)();
exports.userQuery = (0, react_query_1.queryOptions)({
    queryKey: query_keys_1.userKeys.getUser,
    queryFn: userRepository_1.default.getUser,
    select: (data) => {
        const userAvatarToRenderInUi = (0, avatarUtils_1.getSquare)(data.avatarUrl);
        return { ...data, userAvatarToRenderInUi };
    },
});
/**
 * @deprecated The method should not be used, use userQuery instead
 */
const getUserQuery = () => ({
    queryKey: query_keys_1.userKeys.getUser,
    queryFn: userRepository_1.default.getUser,
    select: (data) => {
        const userAvatarToRenderInUi = (0, avatarUtils_1.getSquare)(data.avatarUrl);
        return { ...data, userAvatarToRenderInUi };
    },
});
exports.getUserQuery = getUserQuery;
/**
 * @deprecated The method should not be used, use userQuery instead
 */
const useGetUserQuery = () => {
    return (0, react_query_1.useQuery)(exports.userQuery);
};
exports.useGetUserQuery = useGetUserQuery;
const getUsersByRoleId = (roleId = '') => ({
    queryKey: query_keys_1.userKeys.getUsersByRoleId(roleId),
    queryFn: () => userRepository_1.default.getUsersByRoleId(roleId),
});
exports.getUsersByRoleId = getUsersByRoleId;
const useGetUsersByRoleId = (roleId = '') => {
    return (0, react_query_1.useQuery)((0, exports.getUsersByRoleId)(roleId));
};
exports.useGetUsersByRoleId = useGetUsersByRoleId;
const userByIdQuery = (id = '') => (0, react_query_1.queryOptions)({
    queryKey: query_keys_1.userKeys.getUserById(id),
    queryFn: () => userRepository_1.default.getUserById(id),
    enabled: Boolean(id),
});
exports.userByIdQuery = userByIdQuery;
const useGetUserByEmailQuery = (email = '', enableCheckUser = false) => {
    return (0, react_query_1.useQuery)({
        queryKey: query_keys_1.userKeys.getUserByEmail(email),
        queryFn: () => userRepository_1.default.getUserByEmail(encodeURIComponent(email)),
        enabled: Boolean(email && email.length > 0 && enableCheckUser),
    });
};
exports.useGetUserByEmailQuery = useGetUserByEmailQuery;
const useSendUserInvitationQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: (user) => userRepository_1.default.sendInvitation(user),
        onSuccess: async () => {
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.teamKeys.getTeam],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.teamKeys.getTeamUsers],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.userKeys.getUsersByRoleId(appConstants_1.overviewConstants.COMPANY_ADMIN)],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.userKeys.getUsersByRoleId(appConstants_1.overviewConstants.TEAM_ADMIN)],
            });
        },
        onError: async (error, _variables, context) => {
            logger.error(`Error in sending invitation: ${error}`);
            logger.error(`Context Error in sending invitation: ${context}`);
        },
    });
};
exports.useSendUserInvitationQuery = useSendUserInvitationQuery;
const getVerifyUserAccessQuery = (props) => ({
    queryKey: [query_keys_1.userKeys.getVerifyUserAccess(props)],
    queryFn: () => userRepository_1.default.verifyAccess(props),
});
exports.getVerifyUserAccessQuery = getVerifyUserAccessQuery;
const useGetVerifyUserAccess = (props) => {
    return (0, react_query_1.useQuery)({
        ...(0, exports.getVerifyUserAccessQuery)(props),
    });
};
exports.useGetVerifyUserAccess = useGetVerifyUserAccess;
const useSaveUserDataQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: userRepository_1.default.saveUserData,
        onSettled: () => {
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.userKeys.getUser],
            });
        },
    });
};
exports.useSaveUserDataQuery = useSaveUserDataQuery;
const useSaveUserSettingQuery = () => {
    const queryClient = (0, react_query_1.useQueryClient)();
    return (0, react_query_1.useMutation)({
        mutationFn: ({ selectedTeamID }) => {
            if (selectedTeamID) {
                return userSettingRepository_1.UserSettingRepository.saveUserSetting({ selectedTeamID });
            }
            else {
                throw new Error('selectedTeamID is required');
            }
        },
        onSettled: () => {
            return queryClient.invalidateQueries({
                queryKey: [query_keys_1.userKeys.getUserSettings, 'selectedTeamID'],
                type: 'active',
                exact: true,
            });
        },
    });
};
exports.useSaveUserSettingQuery = useSaveUserSettingQuery;
const useSaveUserAvatarQuery = () => {
    const queryClient = (0, react_query_1.useQueryClient)();
    return (0, react_query_1.useMutation)({
        mutationFn: ({ avatar, user }) => userRepository_1.default.saveAvatar({ avatar, user }),
        onSettled: () => {
            void queryClient.invalidateQueries({
                queryKey: [query_keys_1.userKeys.getUser],
            });
        },
    });
};
exports.useSaveUserAvatarQuery = useSaveUserAvatarQuery;
